import type { PasswordFieldProps } from './PasswordField.types';
import classes from './PasswordField.module.css';
import { Input } from '../Input';
import { EyeIcon } from '../../assets/icons';
import React from 'react';
import clsx from 'clsx';

export const PasswordField = (props: PasswordFieldProps) => {
    const [showPassword, setShowPassword] = React.useState<boolean>(false);
    const { id, name, onChange, value, disabled, error, label, helperText, className, required, onKeyDown, placeholder } = props;

    const displayPassword = () => {
        setShowPassword((prevState) => !prevState);
    };

    // Track password value if empty to set the input type to password
    React.useEffect(() => {
        if (value.length < 1) {
            setShowPassword(false);
        }
    }, [value]);

    return (
        <div className={clsx(classes.root, className)}>
            <Input
                id={id + '-password-field'}
                type={!showPassword ? 'password' : 'text'}
                value={value}
                onChange={onChange}
                name={name}
                label={label}
                helperText={helperText}
                disabled={disabled}
                status={error ? 'error' : undefined}
                required={required}
                icon={value.length > 0 ? <EyeIcon onClick={displayPassword} show={showPassword} /> : undefined}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
            />
        </div>
    );
};

PasswordField.displayName = 'PasswordField';
